import { Control, useController } from 'react-hook-form';

import { BrandSelectionFormValues } from './types';
import { createSubUseCasesCountValidator, useCaseRequired } from './validators';
import { isRequired } from '../../validators';

export const useControllers = (
  control: Control<BrandSelectionFormValues, any, BrandSelectionFormValues>
) => {
  const {
    field: { value: brandUid, onChange: setBrandUid },
  } = useController({
    control,
    name: 'brandUid',
  });
  const {
    field: { value: brandName, onChange: setBrandName },
    fieldState: { error: brandNameError },
  } = useController({
    control,
    name: 'brandName',
    rules: {
      validate: {
        isRequired,
      },
    },
  });
  const {
    field: { value: channelId, onChange: setChannelId },
    fieldState: { error: channelIdError },
  } = useController({
    control,
    name: 'channelId',
    rules: {
      validate: {
        isRequired,
      },
    },
  });
  const {
    field: { value: tenDlcUseCase, onChange: setTenDlcUseCase },
    fieldState: { error: tenDlcUseCaseError },
  } = useController({
    control,
    name: 'tenDlcUseCase',
    disabled: channelId !== '10DLC',
    rules: {
      validate: {
        useCaseRequired,
      },
    },
  });
  const {
    field: { value: tenDlcSubUseCases, onChange: setTenDlcSubUseCases },
    fieldState: { error: tenDlcSubUseCasesError },
  } = useController({
    control,
    name: 'tenDlcSubUseCases',
    disabled: channelId !== '10DLC',
    rules: {
      validate: {
        withValidCount: createSubUseCasesCountValidator(
          tenDlcUseCase?.minSubUsecases ?? 0,
          tenDlcUseCase?.maxSubUsecases ?? 0
        ),
      },
    },
  });
  const {
    field: { value: hostingRegion, onChange: setHostingRegion },
    fieldState: { error: hostingRegionError },
  } = useController({
    control,
    name: 'hostingRegion',
    disabled: channelId !== 'RCS',
    rules: {
      validate: {
        isRequired,
      },
    },
  });
  const {
    field: { value: billingCategory, onChange: setBillingCategory },
    fieldState: { error: billingCategoryError },
  } = useController({
    control,
    name: 'billingCategory',
    disabled: channelId !== 'RCS',
    rules: {
      validate: {
        isRequired,
      },
    },
  });
  const {
    field: { value: rcsUseCase, onChange: setRcsUseCase },
    fieldState: { error: rcsUseCaseError },
  } = useController({
    control,
    name: 'rcsUseCase',
    disabled: channelId !== 'RCS',
    rules: {
      validate: {
        isRequired,
      },
    },
  });

  return {
    brandUid,
    setBrandUid,
    brandName,
    setBrandName,
    brandNameError,
    channelId,
    setChannelId,
    channelIdError,
    tenDlcUseCase,
    setTenDlcUseCase,
    tenDlcUseCaseError,
    tenDlcSubUseCases,
    setTenDlcSubUseCases,
    tenDlcSubUseCasesError,
    hostingRegion,
    setHostingRegion,
    hostingRegionError,
    billingCategory,
    setBillingCategory,
    billingCategoryError,
    rcsUseCase,
    setRcsUseCase,
    rcsUseCaseError,
  };
};
